import React from "react";
import {
  HeaderView,
  AddUser,
  BirthdaysEditor,
  BugReportView,
  ClientsEditor,
  DraftsView,
  EmailsHistory,
} from "../views";
import KeywordEditor from "../views/KeywordEditor";
import ParsersPanelView from "../views/parsers_panel/ParsersPanelView";
import { useAppState } from "../store/app/hooks";

const ParsersPanelPage: React.FC = () => {
  const { modal } = useAppState();

  return (
    <>
      <HeaderView />
      <ParsersPanelView />

      {modal === "client-editor" && <ClientsEditor />}
      {modal === "keyword-editor" && <KeywordEditor />}
      {modal === "add-user" && <AddUser />}
      {modal === "emails-history" && <EmailsHistory />}
      {modal === "birthdays-editor" && <BirthdaysEditor />}
      {modal === "drafts" && <DraftsView />}
      {modal === "bug_report" && <BugReportView />}
    </>
  );
};

export default ParsersPanelPage;
